import axios from 'axios';
import { API_BASE_URL } from './utils';

const API_URL = API_BASE_URL;

const customerApi = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

customerApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('customer_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

customerApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('customer_token');
      localStorage.removeItem('customer_user');
      if (window.location.pathname.startsWith('/customers')) {
        window.location.href = '/customers/login';
      }
    }
    return Promise.reject(error);
  }
);

export const customerAuthAPI = {
  login: (data) => customerApi.post('/customer/auth/login', data),
  me: () => customerApi.get('/customer/me'),
};

export const customerAiChatAPI = {
  getSession: () => customerApi.get('/customer/ai-chat/session'),
  getUnread: () => customerApi.get('/customer/ai-chat/unread'),
  markRead: () => customerApi.post('/customer/ai-chat/mark-read'),
  setLanguage: (language) =>
    customerApi.post('/customer/ai-chat/language', { language }),
};

export default customerApi;
